import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import App from "./App";
import { useLocation } from "react-router";

ReactDOM.render(
  <React.StrictMode>
    <App useLocation={useLocation} />
  </React.StrictMode>,
  document.getElementById("root")
);
